(function ($) {
    $token_url = "https://ig.instant-tokens.com/users/b2825dfc-96f7-4d09-8efe-96cab39c4773/instagram/17841406568978076/token?userSecret=pr6cy32a31r9fo2ram802e";
    if ($("#instafeed").length) {
        const instaCount = $('.news-container').data('instagram-count');
        $.get($token_url, function (data) {
            data = JSON.parse(data);
            var feed = new Instafeed({
                accessToken: data.Token,
                limit: instaCount,
                // template:
                //   '<div class="item"><a href="{{link}}" title="Instagram image" target="_blank" rel="noopener noreferrer"><img src="{{image}}" alt="Instagram image" /><div class="wrapper"><p class="caption">{{caption}}</p></div></a></div>',
                // template: ` <div class="insta-box"><a href="{{link}}" style="--img: url({{image}});" title="{{caption}}" target="_blank" rel="noopener noreferrer"> </a> </div>`,
                template: ` <div class="insta-box"><a href="{{link}}" target="_blank" rel="noopener noreferrer"><img src="{{image}}" alt="{{caption}}"> </a> </div>`,
                // after: function() {
                //     const boxes = $('.insta-box > a');
                //     let counter = 0;
                //     boxes.each(function() {
                //         const $this = $(this);
                //         const holder = $('.insta-holder-' + counter);
                //         // holder.html($this.find('a'));
                //         $this.clone().appendTo(holder);
                //         counter++;
                //     })
                // }
            });
            feed.run();
        });
    }
})(_jQ3);

{
  /* <img src="{{image}}" alt="Instagram image"></img> */
}
